module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('grid-x', {
    attrs: {
      "col": "1fr 1fr 1fr",
      "row": "1fr",
      "gap": "2em"
    }
  }, [_c('div', {
    staticClass: "col-1"
  }, [_c('h3', [_vm._v("Pages")]), _vm._v(" "), _c('page-list', {
    attrs: {
      "data-pages": _vm.pages
    },
    on: {
      "page-data": function($event) {
        _vm.selectPage($event)
      }
    }
  }), _vm._v(" "), _c('h3', [_vm._v("New Page")]), _vm._v(" "), _c('div', {
    staticClass: "new-page"
  }, [_c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPageName),
      expression: "newPageName"
    }],
    ref: "newPage",
    attrs: {
      "type": "text",
      "placeholder": "New Page Name"
    },
    domProps: {
      "value": (_vm.newPageName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPageName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.addPage()
      }
    }
  }, [_vm._v("Create Page")])]), _vm._v(" "), (_vm.currentPage.id) ? _c('div', [_c('h4', [_vm._v("Current Page Key")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.currentPage.id))])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('h3', [_vm._v("Widgets")]), _vm._v(" "), (_vm.currentPageWidgets) ? _c('div', [_c('div', {
    staticClass: "widget-buttons"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.refreshWidget(_vm.currentPage.id)
      }
    }
  }, [_vm._v("UPDATE")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.testPage(_vm.currentPage.id)
      }
    }
  }, [_vm._v("TEST")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.updateWidgetMessage))])]), _vm._v(" "), _c('draggable', {
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "end": function($event) {
        _vm.drag = false
      },
      "change": _vm.reorderWidgetItems
    },
    model: {
      value: (_vm.currentPageWidgets),
      callback: function($$v) {
        _vm.currentPageWidgets = $$v
      },
      expression: "currentPageWidgets"
    }
  }, _vm._l((_vm.currentPageWidgets), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "draggable-items flex center-flex-y flex-space-between",
      class: _vm.activeClass(item.id, _vm.currentWidget.id),
      on: {
        "click": function($event) {
          _vm.selectWidget(item)
        }
      }
    }, [_c('div', {
      staticClass: "flex center-flex-y"
    }, [_c('svg', {
      staticClass: "draggable-icon",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "fill": "none",
        "d": "M0 0h24v24H0V0z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.data.name))])]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          _vm.removeWidget(item)
        }
      }
    }, [_vm._v("Remove")])])
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('h3', [_vm._v("Current Widget Type")]), _vm._v(" "), _c('p', {
    staticClass: "widget-type"
  }, [_vm._v("Type: " + _vm._s(_vm.currentWidget.data.type))]), _vm._v(" "), _c('p', {
    staticClass: "widget-type"
  }, [_vm._v("ID: " + _vm._s(_vm.currentWidget.id))]), _vm._v(" "), _c('h3', [_vm._v("New / Update Widget")]), _vm._v(" "), _c('div', {
    staticClass: "widget-buttons"
  }, [_c('button', {
    class: _vm.newWidgetButton === 'new' ? 'active-button' : '',
    on: {
      "click": function($event) {
        _vm.newWidgetButton = 'new'
      }
    }
  }, [_vm._v("Create Widget")]), _vm._v(" "), (_vm.currentWidget) ? _c('button', {
    class: _vm.newWidgetButton === 'update' ? 'active-button' : '',
    on: {
      "click": function($event) {
        _vm.newWidgetButton = 'update'
      }
    }
  }, [_vm._v("Update Current Widget")]) : _vm._e()])]), _vm._v(" "), (_vm.newWidgetButton === 'new') ? _c('div', {
    staticClass: "new-widget-container"
  }, [_c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newWidgetType),
      expression: "newWidgetType"
    }],
    attrs: {
      "placeholder": "Widget Type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newWidgetType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Widget Type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "mm-html"
    }
  }, [_vm._v("HTML")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "hero"
    }
  }, [_vm._v("Hero")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "top-stories"
    }
  }, [_vm._v("Top Stories")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "listen"
    }
  }, [_vm._v("Listen")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "vertical-article-block"
    }
  }, [_vm._v("Left-Right Block")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "three-row-column"
    }
  }, [_vm._v("Three Articles Bordered")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "grid-three"
    }
  }, [_vm._v("Three Column Grid")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "grid-four"
    }
  }, [_vm._v("Four Column Grid")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "capsule-block"
    }
  }, [_vm._v("Capsule Block")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "infinite-grid-four"
    }
  }, [_vm._v("Infinite Scroll Four Grid")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "horizontal-scroller"
    }
  }, [_vm._v("Horizontal Scroller")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all-podcasts"
    }
  }, [_vm._v("Podcast Playlist Grid")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all-episodes"
    }
  }, [_vm._v("Podcast Episodes Grid")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "podcast-carousel"
    }
  }, [_vm._v("Podcast Carousel")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "author-carousel"
    }
  }, [_vm._v("Author Carousel")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "watch-header"
    }
  }, [_vm._v("Video Hero")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "horizontal-scroller-video"
    }
  }, [_vm._v("Video Horizontal Scroller")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all-video-topics"
    }
  }, [_vm._v("Video Playlist Grid")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all-episodes-video"
    }
  }, [_vm._v("Video Episodes Grid 3")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all-videos"
    }
  }, [_vm._v("Video Episodes Grid 4")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "title-with-lines"
    }
  }, [_vm._v("Title With Lines")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "dynamic-ad-slot"
    }
  }, [_vm._v("Dynamic Ad Slot")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "menu-podcasts"
    }
  }, [_vm._v("MENU Playlists Podcast")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "menu-video-playlists"
    }
  }, [_vm._v("MENU Playlists Videos")])])]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newWidgetStyle),
      expression: "newWidgetStyle"
    }],
    attrs: {
      "type": "text",
      "placeholder": "New Widget Style"
    },
    domProps: {
      "value": (_vm.newWidgetStyle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newWidgetStyle = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newWidgetName),
      expression: "newWidgetName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "New Widget Name"
    },
    domProps: {
      "value": (_vm.newWidgetName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newWidgetName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newWidgetLink),
      expression: "newWidgetLink"
    }],
    attrs: {
      "type": "text",
      "placeholder": "New Widget Link"
    },
    domProps: {
      "value": (_vm.newWidgetLink)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newWidgetLink = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box down-caret"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showTitle),
      expression: "showTitle"
    }],
    attrs: {
      "type": "checkbox",
      "id": "newShowTitleCheckbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showTitle) ? _vm._i(_vm.showTitle, null) > -1 : (_vm.showTitle)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.showTitle,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showTitle = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showTitle = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showTitle = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "newShowTitleCheckbox"
    }
  }, [_vm._v("Show Title " + _vm._s(_vm.showTitle))])]), _vm._v(" "), (_vm.newWidgetType === 'grid-four') ? _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.infiniteScroll),
      expression: "infiniteScroll"
    }],
    attrs: {
      "type": "checkbox",
      "id": "newInfinteScrollCheckbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.infiniteScroll) ? _vm._i(_vm.infiniteScroll, null) > -1 : (_vm.infiniteScroll)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.infiniteScroll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.infiniteScroll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.infiniteScroll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.infiniteScroll = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "newInfinteScrollCheckbox"
    }
  }, [_vm._v("Infinite Scroll " + _vm._s(_vm.infiniteScroll))])]) : _vm._e(), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.addWidget()
      }
    }
  }, [_vm._v("Save Widget")])]) : _vm._e(), _vm._v(" "), (_vm.newWidgetButton === 'update') ? _c('div', {
    staticClass: "update-widget-container"
  }, [_c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.data.type),
      expression: "currentWidget.data.type"
    }],
    attrs: {
      "placeholder": "Current Widget Type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.currentWidget.data, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Widget Type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "mm-html"
    }
  }, [_vm._v("HTML")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "hero"
    }
  }, [_vm._v("Hero")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "top-stories"
    }
  }, [_vm._v("Top Stories")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "listen"
    }
  }, [_vm._v("Listen")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "vertical-article-block"
    }
  }, [_vm._v("Left-Right Block")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "three-row-column"
    }
  }, [_vm._v("Three Articles Bordered")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "grid-three"
    }
  }, [_vm._v("Three Column Grid")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "grid-four"
    }
  }, [_vm._v("Four Column Grid")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "capsule-block"
    }
  }, [_vm._v("Capsule Block")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "infinite-grid-four"
    }
  }, [_vm._v("Infinite Scroll Four Grid")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "horizontal-scroller"
    }
  }, [_vm._v("Horizontal Scroller")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all-podcasts"
    }
  }, [_vm._v("Podcast Playlist Grid")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all-episodes"
    }
  }, [_vm._v("Podcast Episodes Grid")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "podcast-carousel"
    }
  }, [_vm._v("Podcast Carousel")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "author-carousel"
    }
  }, [_vm._v("Author Carousel")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "watch-header"
    }
  }, [_vm._v("Video Hero")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "horizontal-scroller-video"
    }
  }, [_vm._v("Video Horizontal Scroller")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all-video-topics"
    }
  }, [_vm._v("Video Playlist Grid")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all-episodes-video"
    }
  }, [_vm._v("Video Episodes Grid 3")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all-videos"
    }
  }, [_vm._v("Video Episodes Grid 4")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "title-with-lines"
    }
  }, [_vm._v("Title With Lines")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "dynamic-ad-slot"
    }
  }, [_vm._v("Dynamic Ad Slot")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "menu-podcasts"
    }
  }, [_vm._v("MENU Playlists Podcast")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "menu-video-playlists"
    }
  }, [_vm._v("MENU Playlists Videos")])])]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.data.style),
      expression: "currentWidget.data.style"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Current Widget Styles"
    },
    domProps: {
      "value": (_vm.currentWidget.data.style)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentWidget.data, "style", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.data.name),
      expression: "currentWidget.data.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Current Widget Name"
    },
    domProps: {
      "value": (_vm.currentWidget.data.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentWidget.data, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.data.link),
      expression: "currentWidget.data.link"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Current Widget Link"
    },
    domProps: {
      "value": (_vm.currentWidget.data.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentWidget.data, "link", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box input-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.data.showTitle),
      expression: "currentWidget.data.showTitle"
    }],
    attrs: {
      "type": "checkbox",
      "id": "updateShowTitleCheckbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.currentWidget.data.showTitle) ? _vm._i(_vm.currentWidget.data.showTitle, null) > -1 : (_vm.currentWidget.data.showTitle)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.currentWidget.data.showTitle,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.currentWidget.data.showTitle = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.currentWidget.data.showTitle = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.currentWidget.data, "showTitle", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "updateShowTitleCheckbox"
    }
  }, [_vm._v("Show Title " + _vm._s(_vm.currentWidget.data.showTitle))])]), _vm._v(" "), (_vm.currentWidget.data.type === 'grid-four') ? _c('div', {
    staticClass: "input-box input-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.data.infiniteScroll),
      expression: "currentWidget.data.infiniteScroll"
    }],
    attrs: {
      "type": "checkbox",
      "id": "updateInfinteScrollCheckbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.currentWidget.data.infiniteScroll) ? _vm._i(_vm.currentWidget.data.infiniteScroll, null) > -1 : (_vm.currentWidget.data.infiniteScroll)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.currentWidget.data.infiniteScroll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.currentWidget.data.infiniteScroll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.currentWidget.data.infiniteScroll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.currentWidget.data, "infiniteScroll", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "updateInfinteScrollCheckbox"
    }
  }, [_vm._v("Infinite Scroll " + _vm._s(_vm.currentWidget.data.infiniteScroll))])]) : _vm._e(), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.updateWidget()
      }
    }
  }, [_vm._v("Update Widget")])]) : _vm._e()])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex5"
  }, [_c('h3', [_vm._v("Manage Widget")]), _vm._v(" "), (_vm.currentWidget) ? _c('div', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [(_vm.currentWidget.data.type == 'mm-html') ? _c('div', [_c('div', {
    staticClass: "editor-container",
    attrs: {
      "id": "editor-container"
    }
  }, [_c('div', {
    staticClass: "editor-overlay",
    attrs: {
      "id": "editor-overlay"
    }
  }, [_vm._v("Changes Saved")]), _vm._v(" "), _c('div', {
    staticClass: "editor",
    attrs: {
      "id": "editor"
    }
  })]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.saveHtml
    }
  }, [_vm._v("save")])]) : (_vm.currentWidget.data.type == 'dynamic-ad-slot') ? _c('div', [_c('span', [_vm._v("Placement Name")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.data.placementName),
      expression: "currentWidget.data.placementName"
    }],
    attrs: {
      "placeholder": "*required"
    },
    domProps: {
      "value": (_vm.currentWidget.data.placementName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentWidget.data, "placementName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.saveAd
    }
  }, [_vm._v("save")])]) : (_vm.currentWidget.data.type == 'capsule-block') ? _c('div', [_c('h2', [_vm._v("Custom Data")]), _vm._v(" "), _c('div', {
    staticClass: "editor-container",
    attrs: {
      "id": "custom-data-container"
    }
  }, [_c('div', {
    staticClass: "editor-overlay",
    attrs: {
      "id": "custom-editor-overlay"
    }
  }, [_vm._v("Changes Saved")]), _vm._v(" "), _c('div', {
    staticClass: "editor",
    attrs: {
      "id": "custom-editor"
    }
  })]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.saveCustomData
    }
  }, [_vm._v("save")])]) : _c('div', [(_vm.showModalCreate.add || _vm.showModalCreate.edit) ? _c('modal-create', {
    attrs: {
      "podcasts": _vm.podcastPlaylists,
      "videos": _vm.videos,
      "storage": _vm.storage,
      "currentWidget": _vm.currentWidget.data,
      "mode": _vm.showModalCreate
    },
    on: {
      "cancel": _vm.closeModals,
      "create": function($event) {
        _vm.createItem($event)
      },
      "update": function($event) {
        _vm.currentWidget.data.items = $event;
        _vm.updateCurrentWidget();
        _vm.closeModals();
      },
      "edit": _vm.editItem,
      "setWidgetData": function($event) {
        _vm.currentWidget.data[$event.key] = $event.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.checkMode('category', _vm.currentWidget.data.type)) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.setWidgetMode('category');
      }
    }
  }, [_vm._v("Category")]) : _vm._e(), _vm._v(" "), (_vm.checkMode('curated', _vm.currentWidget.data.type)) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.setWidgetMode('curated');
      }
    }
  }, [_vm._v("Curated")]) : _vm._e(), _vm._v(" "), (_vm.checkMode('tags', _vm.currentWidget.data.type)) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.setWidgetMode('tags');
      }
    }
  }, [_vm._v("Tags")]) : _vm._e(), _vm._v(" "), (_vm.checkMode('podcast', _vm.currentWidget.data.type)) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.setWidgetMode('podcasts');
      }
    }
  }, [_vm._v("Podcasts")]) : _vm._e(), _vm._v(" "), (_vm.checkMode('videos', _vm.currentWidget.data.type)) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.setWidgetMode('videos');
      }
    }
  }, [_vm._v("Videos")]) : _vm._e(), _vm._v(" "), (_vm.currentWidget.data.mode == 'curated') ? _c('div', [_c('h2', [_vm._v("Curated")]), _vm._v(" "), _c('draggable', {
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "end": function($event) {
        _vm.drag = false
      },
      "change": _vm.reorderItems
    },
    model: {
      value: (_vm.currentWidget.data.items),
      callback: function($$v) {
        _vm.$set(_vm.currentWidget.data, "items", $$v)
      },
      expression: "currentWidget.data.items"
    }
  }, _vm._l((_vm.currentWidget.data.items), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "draggable-items flex center-flex-y flex-space-between"
    }, [_c('div', {
      staticClass: "flex flex center-flex-y",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('svg', {
      staticClass: "draggable-icon",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "fill": "none",
        "d": "M0 0h24v24H0V0z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
      }
    })]), _vm._v(" "), _c('span', {
      staticStyle: {
        "flex": "1"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), (_vm.checkType(_vm.currentWidget.data.type, 'podcast') || _vm.checkType(_vm.currentWidget.data.type, 'video')) ? _c('button', {
      on: {
        "click": function($event) {
          _vm.removeItem(item, key)
        }
      }
    }, [_vm._v("Remove")]) : _vm._e()])])
  })), _vm._v(" "), (_vm.confirmAddButtonVisible(_vm.currentWidget.data.items)) ? _c('button', {
    staticStyle: {
      "margin-top": "20px"
    },
    on: {
      "click": function($event) {
        _vm.showModalCreate.add = true;
      }
    }
  }, [_vm._v("Add Items")]) : _vm._e(), _vm._v(" "), (_vm.confirmEditButtonVisible(_vm.currentWidget.data.items) && !_vm.checkType(_vm.currentWidget.data.type, 'podcast') && !_vm.checkType(_vm.currentWidget.data.type, 'video')) ? _c('button', {
    staticStyle: {
      "margin-top": "20px"
    },
    on: {
      "click": function($event) {
        _vm.showModalCreate.edit = true;
      }
    }
  }, [_vm._v("Edit")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.currentWidget.data.mode == 'category') ? _c('div', [_c('h2', [_vm._v("Categories")]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Category")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.data.category),
      expression: "currentWidget.data.category"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Category (Blank for all)"
    },
    domProps: {
      "value": (_vm.currentWidget.data.category)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentWidget.data, "category", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Number of articles")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.data.limit),
      expression: "currentWidget.data.limit"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Number of articles"
    },
    domProps: {
      "value": (_vm.currentWidget.data.limit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentWidget.data, "limit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.data.modeOrder),
      expression: "currentWidget.data.modeOrder"
    }],
    attrs: {
      "placeholder": "Widget Type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.currentWidget.data, "modeOrder", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "recent"
    }
  }, [_vm._v("Most Recent")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "popular"
    }
  }, [_vm._v("Most Popular")])])]), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "block"
    },
    on: {
      "click": _vm.saveCategoryMode
    }
  }, [_vm._v("Save")])]) : _vm._e(), _vm._v(" "), (_vm.currentWidget.data.mode == 'podcasts') ? _c('div', [_c('h2', [_vm._v("Podcasts")]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Number of Podcasts")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.data.limit),
      expression: "currentWidget.data.limit"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Number of Podcasts"
    },
    domProps: {
      "value": (_vm.currentWidget.data.limit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentWidget.data, "limit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.data.modeOrder),
      expression: "currentWidget.data.modeOrder"
    }],
    attrs: {
      "placeholder": "Widget Type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.currentWidget.data, "modeOrder", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "recent"
    }
  }, [_vm._v("Most Recent")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "popular"
    }
  }, [_vm._v("Most Popular")])])]), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "block"
    },
    on: {
      "click": _vm.saveCategoryMode
    }
  }, [_vm._v("Save")])]) : _vm._e(), _vm._v(" "), (_vm.currentWidget.data.mode == 'videos') ? _c('div', [_c('h2', [_vm._v("Videos")]), _vm._v(" "), _c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.data.playlists),
      expression: "currentWidget.data.playlists"
    }],
    attrs: {
      "placeholder": "Playlists"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.currentWidget.data, "playlists", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": {
        slug: 'allplaylists',
        title: 'allplaylists'
      }
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.videos), function(item, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": {
          slug: item.id,
          title: item.data.title
        }
      }
    }, [_vm._v(_vm._s(item.title))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Number of videos")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.data.limit),
      expression: "currentWidget.data.limit"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Number of Videos"
    },
    domProps: {
      "value": (_vm.currentWidget.data.limit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentWidget.data, "limit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.data.modeOrder),
      expression: "currentWidget.data.modeOrder"
    }],
    attrs: {
      "placeholder": "Widget Type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.currentWidget.data, "modeOrder", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "recent"
    }
  }, [_vm._v("Most Recent")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "popular"
    }
  }, [_vm._v("Most Popular")])])]), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "block"
    },
    on: {
      "click": _vm.saveCategoryMode
    }
  }, [_vm._v("Save")])]) : _vm._e(), _vm._v(" "), (_vm.currentWidget.data.mode == 'tags') ? _c('div', [_c('h2', [_vm._v("Tags")]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Tag")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.data.tags),
      expression: "currentWidget.data.tags"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Tag (ONLY ONE)"
    },
    domProps: {
      "value": (_vm.currentWidget.data.tags)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentWidget.data, "tags", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Number of articles")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.data.limit),
      expression: "currentWidget.data.limit"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Number of articles"
    },
    domProps: {
      "value": (_vm.currentWidget.data.limit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentWidget.data, "limit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWidget.data.modeOrder),
      expression: "currentWidget.data.modeOrder"
    }],
    attrs: {
      "placeholder": "Widget Type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.currentWidget.data, "modeOrder", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "recent"
    }
  }, [_vm._v("Most Recent")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "popular"
    }
  }, [_vm._v("Most Popular")])])]), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "block"
    },
    on: {
      "click": _vm.saveTagMode
    }
  }, [_vm._v("Save")])]) : _vm._e()], 1)]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06600d67"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/widgets.vue
// module id = 621
// module chunks = 1